import React, { useContext } from 'react'
import { useTheme } from 'styled-components'

import { DashboardContext } from 'live/context/dashboard'
import i18n from 'live/services/i18n'

import {
    hazardBoxHeight,
    hazardTextAreaMargin,
    hazardBoxWidth,
    topEventRadius,
    unfocusOpacity
} from '../../../../../../../utils/constants'
import { TextContainer, TopBarStyledContainer } from './styles'

interface Props {
    threatsX: number
    consequencesX: number
    relativeMiddleX: number
    relativeMiddleY: number
    scale: number
    hazard: string
    widgetWidth: number
    noPreventionMitigation?: boolean
    onHazardClick?: () => void
    focus?: 'unfocus' | 'focus' | 'none'
}
const TopBar: React.FC<Props> = ({
    threatsX,
    consequencesX,
    relativeMiddleX,
    scale,
    widgetWidth,
    hazard,
    noPreventionMitigation,
    onHazardClick,
    focus
}) => {
    const theme = useTheme()
    const relativeTopEventRadius = topEventRadius * scale

    const threatsWidth = relativeMiddleX - relativeTopEventRadius + (threatsX + relativeMiddleX) * scale
    const preventionWidth = -(threatsX + relativeMiddleX) * scale
    const mitigationWidth = (consequencesX - relativeMiddleX - 15) * scale
    const consequenceWidth = widgetWidth - (relativeMiddleX - (relativeMiddleX - consequencesX - 75) * scale)
    // const centerOfTopEvent = relativeMiddleY * (1 / scale)

    /* #TODO splitWords is not a good aproach search for a better one */
    // const hazardWordWidth = 33
    // const hazardSplited = hazard && splitWords(hazard, hazardWordWidth - 10)
    // const pathY = 30 * (hazardSplited?.length || 1) - (hazardSplited?.length > 1 ? 10 * (hazardSplited.length - 1) : 0)

    const { theme: dashTheme } = useContext(DashboardContext)

    const drawHazardBackgroud = (
        <>
            <rect x="0.953125" y="0.643188" width="371.73" height="235.731" fill="black" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.953125 0.643188H16.0641L46.286 236.374H31.1751L0.953125 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M121.841 0.643188H136.952L167.174 236.374H152.063L121.841 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M242.729 0.643188H257.839L288.061 236.374H272.95L242.729 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M61.397 0.643188H76.5079L106.73 236.374H91.6189L61.397 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M182.285 0.643188H197.396L227.618 236.374H212.507L182.285 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M303.172 0.643188H318.283L348.505 236.374H333.394L303.172 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.175 0.643188H46.286L76.5079 236.374H61.397L31.175 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M152.063 0.643188H167.174L197.396 236.374H182.285L152.063 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M272.951 0.643188H288.062L318.284 236.374H303.173L272.951 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M91.6189 0.643188H106.73L136.952 236.374H121.841L91.6189 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M212.507 0.643188H227.618L257.839 236.374H242.729L212.507 0.643188Z"
                fill="#FFE600"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M333.394 0.643188H348.505C348.505 0.643188 372.683 187.631 372.683 203.317C372.683 219.002 372.683 236.374 372.683 236.374H363.616L333.394 0.643188Z"
                fill="#FFE600"
            />
        </>
    )

    const drawHazard = (
        <g
            id="hazard"
            transform={`translate(${relativeTopEventRadius}, ${40}) scale(${scale})`}
            onClick={onHazardClick}
            style={{ cursor: 'pointer' }}
            opacity={focus === 'unfocus' ? unfocusOpacity : 1}
        >
            <g transform={`translate(${-(hazardBoxWidth / 2)}, ${0})`}>
                <svg
                    width={hazardBoxWidth}
                    height={hazardBoxHeight}
                    viewBox={`0 0 ${hazardBoxWidth} ${hazardBoxHeight}`}
                    fill="none"
                >
                    {drawHazardBackgroud}
                </svg>
                <rect
                    x={0}
                    y={0}
                    fill={theme['blue-500']}
                    width={hazardBoxWidth}
                    height={hazardBoxHeight}
                    opacity={focus === 'focus' ? 1 : 0}
                />
                <rect
                    x={hazardTextAreaMargin}
                    y={hazardTextAreaMargin}
                    fill={theme['gray-0']}
                    width={hazardBoxWidth - hazardTextAreaMargin * 2}
                    height={hazardBoxHeight - hazardTextAreaMargin * 2}
                />
                <foreignObject
                    x={hazardTextAreaMargin}
                    y={hazardTextAreaMargin}
                    width={hazardBoxWidth - hazardTextAreaMargin * 2}
                    height={hazardBoxHeight - hazardTextAreaMargin * 2}
                    style={{ overflow: 'hidden' }}
                >
                    <TextContainer>{hazard}</TextContainer>
                </foreignObject>
            </g>
        </g>
    )

    return (
        <TopBarStyledContainer id="bowtie-topbar" dashTheme={dashTheme}>
            {/* Threats */}
            <g>
                <rect
                    className="TopBar-bar"
                    fill="#def8f8"
                    width={
                        (noPreventionMitigation ? threatsWidth + preventionWidth : threatsWidth) < 0
                            ? 0
                            : noPreventionMitigation
                            ? threatsWidth + preventionWidth
                            : threatsWidth
                    }
                    height={20}
                />
                <text
                    x={
                        ((noPreventionMitigation ? threatsWidth + preventionWidth : threatsWidth) < 0
                            ? 0
                            : noPreventionMitigation
                            ? threatsWidth + preventionWidth
                            : threatsWidth) / 2
                    }
                    y={10}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    opacity={threatsWidth < 92 ? 0 : 1}
                    fontWeight={600}
                >
                    {i18n('THREAT')}
                </text>
            </g>

            {/* Prevention */}
            {!noPreventionMitigation && (
                <g transform={`translate(${threatsWidth}, ${0})`}>
                    <rect
                        className="TopBar-bar"
                        fill="#e0f8de"
                        width={preventionWidth < 0 ? 0 : preventionWidth}
                        height={20}
                    />
                    <text
                        x={(preventionWidth < 0 ? 0 : preventionWidth) / 2}
                        y={10}
                        textAnchor="middle"
                        dominantBaseline="middle"
                        opacity={preventionWidth < 100 ? 0 : 1}
                        fontWeight={600}
                    >
                        {i18n('PREVENTION')}
                    </text>
                </g>
            )}

            {/* Mitigation */}
            {!noPreventionMitigation && (
                <g transform={`translate(${relativeMiddleX + relativeTopEventRadius}, ${0})`}>
                    <rect
                        className="TopBar-bar"
                        height={20}
                        width={mitigationWidth < 0 ? 0 : mitigationWidth}
                        fill="#f9eccc"
                    />
                    <text
                        x={(mitigationWidth < 0 ? 0 : mitigationWidth) / 2}
                        y={10}
                        textAnchor="middle"
                        dominantBaseline="middle"
                        opacity={mitigationWidth < 100 ? 0 : 1}
                        fontWeight={600}
                    >
                        {i18n('MITIGATION')}
                    </text>
                </g>
            )}
            {/* Consequence */}
            <g
                transform={`translate(${relativeMiddleX -
                    (noPreventionMitigation ? mitigationWidth : 0) -
                    (relativeMiddleX - consequencesX - 75) * scale}, ${0})`}
            >
                <rect
                    className="TopBar-bar"
                    fill="#DCCEF3"
                    width={
                        (noPreventionMitigation ? consequenceWidth + mitigationWidth : consequenceWidth) < 0
                            ? 0
                            : noPreventionMitigation
                            ? consequenceWidth + mitigationWidth
                            : consequenceWidth
                    }
                    height={20}
                />

                <text
                    x={
                        ((noPreventionMitigation ? consequenceWidth + mitigationWidth : consequenceWidth) < 0
                            ? 0
                            : noPreventionMitigation
                            ? consequenceWidth + mitigationWidth
                            : consequenceWidth) / 2
                    }
                    y={10}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontWeight={600}
                    opacity={consequenceWidth < 92 ? 0 : 1}
                >
                    {i18n('CONSEQUENCE')}
                </text>
            </g>

            <g transform={`translate(${relativeMiddleX - relativeTopEventRadius}, ${0})`}>
                <rect
                    className="TopBar-bar"
                    fill="#f9f9cc"
                    x={0}
                    y={0}
                    width={relativeTopEventRadius * 2}
                    height={25}
                />
                <text
                    x={relativeTopEventRadius}
                    y={12.5}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontWeight={600}
                    opacity={relativeTopEventRadius * 2 < 50 ? 0 : 1}
                >
                    {i18n('HAZARD')}
                </text>

                {drawHazard}
            </g>
        </TopBarStyledContainer>
    )
}

export default TopBar
